import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import ReportPlayerFilter from './ReportPlayerFilter';
import { useAppSelector } from '../../../store';
import TotalTable from './TotalTable';
import TableGamers from './TableGamers';
import GamersPagination from './GamersPagination';
import { useDispatch } from 'react-redux';
import { setGamersList, setGamersPayload, setGamersTotal } from '../../../store/apps/reportsSlice';
import { API_REPORT } from '../../../api/report';
import ShowContainer from '../../../components/material-ui/ShowContainer';

export default function ReportPlayersContent() {
  const dispatch = useDispatch();
  const payload = useAppSelector((state) => state.reports.gamers.payload);

  const [loader, setLoader] = useState(false);
  const [empty, setEmpty] = useState(false);

  const pageNo = payload.pageNo;
  const pageSize = payload.pageSize;

  const onFindClick = (newPayload) => {
    const currentPayload = { pageNo, pageSize, ...payload, ...newPayload };

    if (!currentPayload.groupId) {
      const newPageNo = currentPayload.pageNo || pageNo;
      const newPageSize = currentPayload.pageSize || pageSize;
      dispatch(setGamersPayload({ ...payload, pageNo: newPageNo, pageSize: newPageSize }));
      return;
    }

    if (!currentPayload.userId) currentPayload.userId = null;
    const reportPayload = { ...currentPayload };
    if (reportPayload.minDepositCount === 'not') reportPayload.minDepositCount = null;

    setLoader(true);
    API_REPORT.list
      .gamers(reportPayload)
      .then((e) => {
        const data = e.data.data;
        const total = data.total;
        const records = data.records;
        const pageCount = data.pageCount;
        const pageNo = Math.min(data.pageNo, pageCount);
        dispatch(setGamersPayload({ ...currentPayload, pageCount, pageNo }));
        dispatch(setGamersTotal(total));
        dispatch(setGamersList(records));
        setEmpty(!records.length);
      })
      .catch(console.error)
      .finally(() => setLoader(false));
  };

  const showTable = !empty && !loader;

  return (
    <Stack gap={3}>
      <ReportPlayerFilter onFindClick={onFindClick} />
      <Stack gap={4}>
        <ShowContainer condition={showTable}>
          <TotalTable />
        </ShowContainer>
        <Stack gap={1}>
          <TableGamers
            loader={loader}
            empty={empty}
            beginValueIndex={(pageNo - 1) * pageSize + 1}
          />
          <ShowContainer condition={showTable}>
            <GamersPagination onFindClick={onFindClick} />
          </ShowContainer>
        </Stack>
      </Stack>
    </Stack>
  );
}
